import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  Grid,
  FormGroup,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Card,
  CardContent,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import Autocomplete, {
  createFilterOptions,
} from '@mui/material/Autocomplete';
import './styles.css';
import FormControlLabel from '@mui/material/FormControlLabel';
import HandleOptions from '../../components/HandleOptions';
import MenuItem from '@mui/material/MenuItem';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import NewUnity from '../../components/Unity.js';
import { useStyles } from '../../components/Styles';
import { TooltipMain } from '../../components/tooltips/tooltipsMain';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import TopScreenAlert from 'components/TopScreenAlert';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { labelField } from 'utils';

function Parameter() {
  const location = useLocation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const [hasOptions, setHasOptions] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [unities, setUnities] = useState([]);
  const [selectedUnity, handleUnity] = useState(null);
  const disable = useSelector((state) => state.disable.disable);
  const [dialogOpen, toggleOpen] = useState(false);
  const [topDialogOpen, setTopDialogOpen] = useState({
    error: false,
    message: '',
  });
  const [newUnityName, setNewUnityName] = useState('');
  const [isUsade, setIsUsade] = useState(false);
  const filter = createFilterOptions();
  const error = Error();
  const success = Success();

  function setData(data) {
    formik.setValues(data);
    setIsUsade(data.isUsade);
    handleUnity(data.unity);

    if (data.options === null || data.options === undefined) {
      data.options = [];
    }
    if (data.type === null || data.type === undefined) {
      data.type = '';
    }
    if (data.condition === null || data.condition === undefined) {
      data.condition = '';
    }

    setHasOptions(data.hasOptions);
  }

  function deleteOption(options) {
    formik.setFieldValue('options', options);
  }

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/parameters/${id}`, { ...data })
        : await api.post('/parameters', { ...data });
      success();

      history.push('/parameters');
    } catch (err) {
      error(err.response.data.message);
    }
    dispatch(setLoading(false));
    dispatch(setDisable(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
      type: '',
      hasOptions: false,
      options: [],
      max: null,
      min: null,
      default: null,
      message_max: '',
      message_min: '',
      message_defaultless: '',
      condition: '',
      unity: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(100, 'O tamanho máximo do campo é 100 caracteres')
        .required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      unity: Yup.string().required('Campo Obrigatório'),
      description: Yup.string()
        .max(100, 'O tamanho máximo do campo é 100 caracteres')
        .notRequired(),
      options: Yup.mixed().when('hasOptions', {
        is: (val) => !val,
        then: Yup.mixed().notRequired(),
        otherwise: Yup.array().required(
          'Campo Obrigatorio: Digite um valor e aperte enter',
        ),
      }),
    }),
    onSubmit: (values) => {
      dispatch(setLoading(true));

      formik.values.default = !formik.values.default
        ? null
        : formik.values.default;
      formik.values.min = !formik.values.min ? null : formik.values.min;
      formik.values.max = !formik.values.max ? null : formik.values.max;

      request(values);
    },
  });

  useEffect(() => {
    const controller = new AbortController();

    async function load() {
      setOpenProgress(true);

      try {
        const unity_ = await api.get('/unities');

        if (id) {
          const parameterRequest = await api.get(`/parameters/${id}`);

          if (parameterRequest.data) {
            setData(parameterRequest.data);
          }
        }

        setUnities(unity_.data);
      } catch (error) {

      }
      setOpenProgress(false);
    }

    load();
  }, [id]);

  const updateUnities = async (selected) => {
    const unity_ = await api.get('/unities');
    setUnities(unity_.data);
    handleUnity(unity_.data[unity_.data.length - 1]);
    formik.setFieldValue('unity', unity_.data[unity_.data.length - 1].id);
    toggleOpen(false);
  };

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados do Parâmetro
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela você consegue configurar os parâmetros que serão utilizados em medições no sistema.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={12}>
                  <FormGroup>
                    <FormControl>
                      <FormLabel>Tipo do Valor de Entrada</FormLabel>
                      <RadioGroup
                        align="center"
                        row
                        aria-label="position"
                        defaultValue="false"
                        value={hasOptions.toString()}
                        onChange={(e) => {
                          const value = e.target.value === 'true';
                          setHasOptions(value);
                          formik.setFieldValue('hasOptions', value);
                        }}
                      >
                        <FormControlLabel
                          value="false"
                          control={<Radio color="primary" />}
                          label="Numérico"
                          labelPlacement="end"
                          disabled={id && isUsade}
                        />
                        <FormControlLabel
                          value="true"
                          control={<Radio color="primary" />}
                          label="Textual"
                          labelPlacement="end"
                          disabled={id && isUsade}
                        />
                      </RadioGroup>
                      {hasOptions && (
                        <HandleOptions
                          hasOptions={hasOptions}
                          options={formik.values.options}
                          callback={deleteOption}
                          errors={[
                            formik.touched.options,
                            formik.errors.options,
                          ]}
                        />
                      )}
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="name"
                      label={labelField('Nome do Parâmetro')}
                      variant="outlined"
                      name="name"
                      type="text"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.name && formik.errors.name)}
                      helperText={
                        formik.touched.name
                        && formik.errors.name
                        && formik.errors.name
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="outlined-select-currency"
                      select
                      label={labelField('Tipo de Parâmetro', 'Selecione o tipo que mais se encaixa ao novo parâmetro.')}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      variant="outlined"
                      value={formik.values.type}
                      name="type"
                      // as="select"
                      error={!!(formik.touched.type && formik.errors.type)}
                      helperText={
                        formik.touched.type
                        && formik.errors.type
                        && formik.errors.type
                      }
                    >
                      <MenuItem key={1} value="Água">
                        Qualidade da Água
                      </MenuItem>
                      <MenuItem key={2} value="Animal">
                        Biometria
                      </MenuItem>
                      <MenuItem key={3} value="Saúde">
                        Análise de Saúde
                      </MenuItem>
                    </TextField>
                  </FormGroup>
                </Grid>
                {/* {hasOptions === "false" && ( */}
                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <Autocomplete
                      handleHomeEndKeys
                      name="unity"
                      value={selectedUnity}
                      options={unities}
                      onBlur={() => formik.setFieldTouched('unity', true)}
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                          setTimeout(() => {
                            toggleOpen(true);
                            setNewUnityName(newValue);
                          });
                        } else if (newValue && newValue.inputValue) {
                          toggleOpen(true);
                          setNewUnityName(newValue.inputValue);
                        } else {
                          handleUnity(newValue);
                          formik.setFieldValue(
                            'unity',
                            newValue ? newValue.id : '',
                          );
                        }
                      }}
                      getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                          return option;
                        }
                        if (option.inputValue) {
                          return `${option.name} ${option.sigla ? `(${option.sigla})` : ''
                          }`;
                        }
                        return `${option.name} ${option.sigla ? `(${option.sigla})` : ''
                        }`;
                      }}
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        if (params.inputValue !== '') {
                          filtered.push({
                            inputValue: params.inputValue,
                            name: `Adicionar "${params.inputValue}"`,
                          });
                        }

                        return filtered;
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.name}
                          {' '}
                          {option.sigla ? `(${option.sigla})` : ''}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Unidade de Medida')}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            type: 'search',
                          }}
                          error={
                            !!(formik.touched.unity && formik.errors.unity)
                          }
                          helperText={
                            formik.touched.unity
                            && formik.errors.unity
                            && formik.errors.unity
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>

                {/* <FormGroup>
            <TextField
              InputLabelProps={{
                style: { pointerEvents: "auto" },
                shrink: true,
              }}
              id="condition"
              label={<div>Condição (Opcional)</div>}
              fullWidth
              select
              variant="outlined"
              name="condition"
              // as="select"
              SelectProps={{
                displayEmpty: true,
              }}
              value={formik.values.condition}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={!!(formik.touched.condition && formik.errors.condition)}
              helperText={
                formik.touched.condition &&
                formik.errors.condition &&
                formik.errors.condition
              }
            >
              <MenuItem key={0} value="">
                Nenhuma
              </MenuItem>
              <MenuItem key={1} value="Igual">
                Igual
              </MenuItem>
              <MenuItem key={2} value="Mínimo">
                Mínimo
              </MenuItem>
              <MenuItem key={3} value="Máximo">
                Máximo
              </MenuItem>
              <MenuItem key={4} value="Intervalo">
                Intervalo
              </MenuItem>
            </TextField>
          </FormGroup> */}

                {formik.values.condition === 'Igual' ? (
                  <FormGroup>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="default"
                          label={<div>Valor padrão</div>}
                          fullWidth
                          variant="outlined"
                          name="default"
                          type="number"
                          value={formik.values.default}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            !!(formik.touched.default && formik.errors.default)
                          }
                          helperText={
                            formik.touched.default
                            && formik.errors.default
                            && formik.errors.default
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="message_defaultless"
                          label={<div>Mensagem para valor padrão</div>}
                          fullWidth
                          variant="outlined"
                          name="message_defaultless"
                          type="text"
                          value={formik.values.message_defaultless}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            !!(
                              formik.touched.message_defaultless
                              && formik.errors.message_defaultless
                            )
                          }
                          helperText={
                            formik.touched.message_defaultless
                            && formik.errors.message_defaultless
                            && formik.errors.message_defaultless
                          }
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                ) : formik.values.condition === 'Mínimo' ? (
                  <FormGroup>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="min"
                          label={<div>Valor mínimo</div>}
                          fullWidth
                          variant="outlined"
                          name="min"
                          type="number"
                          value={formik.values.min}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={!!(formik.touched.min && formik.errors.min)}
                          helperText={
                            formik.touched.min
                            && formik.errors.min
                            && formik.errors.min
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="message_min"
                          label={<div>Mensagem para valor mínimo</div>}
                          fullWidth
                          variant="outlined"
                          name="message_min"
                          type="text"
                          value={formik.values.message_min}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            !!(
                              formik.touched.message_min
                              && formik.errors.message_min
                            )
                          }
                          helperText={
                            formik.touched.message_min
                            && formik.errors.message_min
                            && formik.errors.message_min
                          }
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                ) : formik.values.condition === 'Máximo' ? (
                  <FormGroup>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="max"
                          label={<div>Valor máximo</div>}
                          fullWidth
                          variant="outlined"
                          name="max"
                          type="number"
                          value={formik.values.max}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.max && formik.errors.max}
                          helperText={
                            formik.touched.max
                            && formik.errors.max
                            && formik.errors.max
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="message_max"
                          label={<div>Mensagem para valor máximo</div>}
                          fullWidth
                          variant="outlined"
                          name="message_max"
                          type="text"
                          value={formik.values.message_max}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            !!(
                              formik.touched.message_max
                              && formik.errors.message_max
                            )
                          }
                          helperText={
                            formik.touched.message_max
                            && formik.errors.message_max
                            && formik.errors.message_max
                          }
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                ) : formik.values.condition === 'Intervalo' ? (
                  <>
                    <FormGroup>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            id="min"
                            label={<div>Valor mínimo</div>}
                            fullWidth
                            variant="outlined"
                            name="min"
                            type="number"
                            value={formik.values.min}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={!!(formik.touched.min && formik.errors.min)}
                            helperText={
                              formik.touched.min
                              && formik.errors.min
                              && formik.errors.min
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            id="message_min"
                            label={<div>Mensagem para valor mínimo</div>}
                            fullWidth
                            variant="outlined"
                            name="message_min"
                            type="text"
                            value={formik.values.message_min}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              !!(
                                formik.touched.message_min
                                && formik.errors.message_min
                              )
                            }
                            helperText={
                              formik.touched.message_min
                              && formik.errors.message_min
                              && formik.errors.message_min
                            }
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>
                    <FormGroup>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            id="max"
                            label={<div>Valor máximo</div>}
                            fullWidth
                            variant="outlined"
                            name="max"
                            type="number"
                            value={formik.values.max}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={!!(formik.touched.max && formik.errors.max)}
                            helperText={
                              formik.touched.max
                              && formik.errors.max
                              && formik.errors.max
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            id="message_max"
                            label={<div>Mensagem para valor máximo</div>}
                            fullWidth
                            variant="outlined"
                            name="message_max"
                            type="text"
                            value={formik.values.message_max}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              !!(
                                formik.touched.message_max
                                && formik.errors.message_max
                              )
                            }
                            helperText={
                              formik.touched.message_max
                              && formik.errors.message_max
                              && formik.errors.message_max
                            }
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>
                  </>
                ) : (
                  <></>
                )}
                <Grid item xs={12} sm={12}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="description"
                      label={<div>Descrição (Opcional)</div>}
                      fullWidth
                      variant="outlined"
                      name="description"
                      type="text"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onKeyDown={formik.handleBlur}
                      error={
                        !!(
                          formik.touched.description
                          && formik.errors.description
                        )
                      }
                      helperText={
                        formik.touched.description
                        && formik.errors.description
                        && formik.errors.description
                      }
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/parameters/"
            routeDelete="/parameters"
            returnRoute="/parameters"
            id={id}
            alert
            disable={disable}
            message="A exclusão desse parâmetro pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
          />
        </form>
        {dialogOpen && (
          <NewUnity
            name={newUnityName}
            open={dialogOpen}
            onSave={updateUnities}
            onClose={() => toggleOpen(false)}
          />
        )}
        {topDialogOpen.error ? (
          <TopScreenAlert message={topDialogOpen.message} />
        ) : (
          ''
        )}
      </Card>
    </header>
  );
}

export default Parameter;
